import { __extends } from "tslib";
import { RenderGroup } from './RenderGroup';
import { RendererBase } from './RendererBase';
import { CacheRenderer } from './CacheRenderer';
import { DefaultRenderer } from './DefaultRenderer';
/**
 * The DepthRenderer class renders 32-bit depth information encoded as RGBA
 *
 * @class away.render.DepthRenderer
 */
var DepthRenderer = /** @class */ (function (_super) {
    __extends(DepthRenderer, _super);
    /**
     * Creates a new DepthRenderer object.
     * @param renderBlended Indicates whether semi-transparent objects should be rendered.
     * @param distanceBased Indicates whether the written depth value is distance-based or projected depth-based
     */
    function DepthRenderer(partition, pool) {
        var _this = _super.call(this, partition, pool) || this;
        _this._traverserGroup = RenderGroup.getInstance(CacheRenderer);
        _this._maskGroup = RenderGroup.getInstance(DefaultRenderer);
        return _this;
    }
    /**
     *
     */
    DepthRenderer.prototype.enterNode = function (node) {
        var enter = node._collectionMark != RendererBase._collectionMark && node.isCastingShadow();
        if (!enter) {
            node._collectionMark = RendererBase._collectionMark;
            return false;
        }
        return _super.prototype.enterNode.call(this, node);
    };
    DepthRenderer.registerMaterial = function (renderMaterialClass, materialClass) {
        RenderGroup.getInstance(DepthRenderer).materialClassPool[materialClass.assetType] = renderMaterialClass;
    };
    DepthRenderer.assetType = '[renderer DepthRenderer]';
    return DepthRenderer;
}(RendererBase));
export { DepthRenderer };
